import apiReq from '../commontools/api.js'
export function GetSalerModules(salerid){
	var url='/SalerModules/GetSalerModules/'+salerid;
	return apiReq.get(url)
}
export function GetSalerModulItemByMid(mid){
	var url='/SalerModuleItem/GetSalerModulItemByMid/'+mid;
	return apiReq.get(url)
}
export function SaveSalerModul(mname,salerid,orderid,groupid){
	var url='/SalerModules/SaveSalerModul/'+mname+'/'+salerid+'/'+orderid+'/'+groupid;
	
	return apiReq.get(url)
}
export function DelSalerModulByID(mid){
	var url='/SalerModules/DelSalerModulByID/'+mid;
	return apiReq.get(url)
}
export default{
	GetSalerModules,
	GetSalerModulItemByMid,
	SaveSalerModul,
	DelSalerModulByID
}